import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import DataTableCurrency from '@/components/datatable/DataTableCurrency.vue';
import BasicSalaryCalculationHoverCard from '@/components/holiday-pay-obligations/BasicSalaryCalculationHoverCard.vue';
import ObligationCalculationHoverCard from '@/components/holiday-pay-obligations/ObligationCalculationHoverCard.vue';
import type { HolidayPayObligationEntry } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<HolidayPayObligationEntry>[] = [
    {
        accessorKey: 'id',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'employee.full_name',
        id: 'employee_name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'holiday-pay-obligations.entries.headers.name',
            }),
    },
    {
        accessorKey: 'employee.department',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'holiday-pay-obligations.entries.headers.department',
            }),
    },
    {
        accessorKey: 'days_outstanding',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'holiday-pay-obligations.entries.headers.days_outstanding',
            }),
        cell: ({ row }) => {
            return h(DataTableCurrency, {
                value: Number(row.original.days_outstanding),
                returnZero: true,
            });
        },
    },
    {
        accessorKey: 'basic_salary',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'holiday-pay-obligations.entries.headers.basic_salary',
            }),
        cell: ({ row }) => {
            return h(BasicSalaryCalculationHoverCard, {
                value: Number(row.original.basic_salary),
                holidayPayObligationEntry: row.original,
            });
        },
    },
    {
        accessorKey: 'obligation',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'holiday-pay-obligations.entries.headers.obligation',
            }),
        cell: ({ row }) => {
            return h(ObligationCalculationHoverCard, {
                value: Number(row.original.obligation),
                holidayPayObligationEntry: row.original,
            });
        },
    },
    {
        accessorKey: 'last_months_obligation',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'holiday-pay-obligations.entries.headers.last_months_obligation',
            }),
        cell: ({ row }) => {
            return h(DataTableCurrency, {
                value: Number(row.original.last_months_obligation),
                returnZero: true,
            });
        },
    },
    {
        accessorKey: 'difference',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'holiday-pay-obligations.entries.headers.export_difference',
            }),
        cell: ({ row }) => {
            return h(DataTableCurrency, {
                value: row.original.difference,
                returnZero: true,
            });
        },
    },
];
